/**
 * ScopeRail — the VIEW TABS on "My inventions" (Story #5648 build v2, figures
 * S4 and S4b: "List · Atlas · Synergy · Overlap · Shape & Strategy · Watch").
 *
 * Two things changed in build v2 and both are removals:
 *
 * 1. The duplicate "My inventions" entry point that used to sit on the page
 *    body above the tabs is GONE. The figure shows that entry point once, in
 *    the sidebar, and nowhere else; a second copy on the page was old shell
 *    furniture the figure does not have.
 * 2. All six tabs the figure shows are built. v1 shipped three and left the
 *    other three out because they were not contracted; the figure is the
 *    contract now, and each of the six leads to a real screen driven by a real
 *    own-scope route (see components/ownscope/).
 *
 * The zoom rail — Invention ‹ › My inventions — is NOT here. That is the
 * spine's FocusRail in the top bar, and it never moves when a tab changes:
 * these are views at one level, not levels.
 */
import { Link } from 'react-router-dom'
import { OWN_SCOPE_TABS, type OwnScopeView } from '../ownscope/ownScopeViews'

export interface ScopeRailProps {
  /** The active view, resolved by the page from ?view=. */
  view: OwnScopeView
}

export default function ScopeRail({ view }: ScopeRailProps) {
  return (
    <nav aria-label="Scope views" className="mb-4 border-b border-iflow-900/10">
      <ul className="flex list-none flex-wrap gap-6">
        {OWN_SCOPE_TABS.map((tab) => {
          const isActive = tab.view === view
          return (
            <li key={tab.view}>
              {/*
                Link, not NavLink: NavLink decides "active" on the PATHNAME
                alone, and all six tabs share /projects — so every tab would
                carry aria-current="page" at once. The view comes from the
                query string, so the active state is computed here.
              */}
              <Link
                to={tab.to}
                aria-current={isActive ? 'page' : undefined}
                className={`inline-block border-b-2 px-1 pb-2 text-[15px] transition-colors
                  ${isActive
                    ? 'border-iflow-500 font-semibold text-iflow-900'
                    : 'border-transparent font-medium text-gray-500 hover:border-gray-300 hover:text-iflow-900'}`}
              >
                {tab.label}
              </Link>
            </li>
          )
        })}
      </ul>
    </nav>
  )
}
